import { IClientGridRow } from '@/Interfaces/Client.interface';
import { Grid } from '@/components/Grid';
import ServerSidePagination from '@/components/Grid/Pagination/ServerSidePagination';
import {
  GridPaginationAndSortFilters,
  useGridApiPaginationAndSort,
} from '@/components/Grid/hooks/useGridApiPaginationAndSort';
import { EXPAND_OPTIONS } from '@/constants/grid';
import { useAppDispatch } from '@/store/hooks';
import { setFilters } from '@/store/slices/clients.slice';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { useCallback } from 'react';
import COLUMNS from './columns';
import Toolbar from './components/Toolbar';

interface IProps {
  data: IClientGridRow[];
  rowCount: number;
  loading: boolean;
  handleCreationModalOpen: () => void;
}

const ClientsGrid = ({ data = [], rowCount, loading, handleCreationModalOpen }: IProps) => {
  const dispatch = useAppDispatch();

  const setTableFilters = useCallback(
    (filters: GridPaginationAndSortFilters) => dispatch(setFilters(filters)),
    [dispatch],
  );

  const { paginationModel, sortModel, handlePaginationModelChange, handleSortModelChange } =
    useGridApiPaginationAndSort({ setFilters: setTableFilters });

  return (
    <div className='grid grid-cols-1'>
      <Grid
        rows={data}
        autosizeOnMount
        autosizeOptions={EXPAND_OPTIONS}
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        showCellVerticalBorder
        showColumnVerticalBorder
        columns={COLUMNS}
        columnHeaderHeight={30}
        sortingMode='server'
        paginationMode='server'
        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationModelChange}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        pagination
        slots={{
          toolbar: Toolbar,
          pagination: ServerSidePagination,
          columnSortedAscendingIcon: KeyboardArrowUp,
          columnSortedDescendingIcon: KeyboardArrowDown,
        }}
        slotProps={{
          pagination: {
            // @ts-expect-error pagination loading
            loading,
            rowCount,
          },
          footer: {
            className: 'relative',
          },
          toolbar: {
            total: rowCount,
            handleCreationModalOpen,
          },
        }}
      />
    </div>
  );
};

export default ClientsGrid;
